import { useEffect, useRef, useState } from "react";
import { AppUpdateBar } from "./AppUpdateBar";
import { takeUpdateReloadSuppression } from "./cachePolicy";
import { registerProductionUpdate } from "./registerAppUpdate";

function e2eUpdateRequested(): boolean {
  if (import.meta.env.MODE !== "e2e") return false;
  return new URLSearchParams(window.location.search).has("pwa-update");
}

export function AppUpdateNotifier() {
  // Cleared on read. Hides the update this reload just applied, not a later one.
  const [reloadedForUpdate] = useState(() =>
    takeUpdateReloadSuppression(sessionStorage),
  );
  const [open, setOpen] = useState(
    () => !reloadedForUpdate && e2eUpdateRequested(),
  );
  const [ready, setReady] = useState(false);
  const acceptRef = useRef<() => void>(() => {});

  useEffect(() => {
    const session = registerProductionUpdate(
      () => {
        setOpen(true);
      },
      reloadedForUpdate,
      () => {
        setOpen(false);
      },
    );
    acceptRef.current = () => {
      session.acceptUpdate();
    };
    setReady(true);
  }, [reloadedForUpdate]);

  return (
    <AppUpdateBar
      open={open}
      ready={ready}
      onRefresh={() => {
        acceptRef.current();
      }}
    />
  );
}
